exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex.align-items-center.mt-2[data-v-68e7755c]{margin-top:.2rem!important}", ""]);

// exports
